import React, { FormEvent, useCallback, useState } from 'react';
import { Group, GroupId } from 'shared/models';
import { useTranslation } from 'react-i18next';
import { RadioField } from 'ui/shared/controls';
import { Dialog } from 'ui/shared/containers';

require('./AssignDeviceToElevatorDialog.css');

export type Props = {
    visible: boolean;
    busy: boolean;
    elevators: Group[];
    machineRoom?: Group | null; // This will be set when the device is a relay device; otherwise it's null
    defaultElevatorId: GroupId;
    onAssign(elevatorId: GroupId): void;
    onCancel(): void;
};

export const AssignDeviceToElevatorDialog = ({ visible, busy, elevators, machineRoom = null, defaultElevatorId, onAssign, onCancel }: Props) => {
    const { t } = useTranslation();

    const [ selectedElevatorId, setSelectedElevatorId ] = useState(defaultElevatorId);

    const handleChange = useCallback((e: FormEvent<HTMLInputElement>) => {
        if (e.currentTarget.checked) {
            setSelectedElevatorId(e.currentTarget.value);
        }
    }, [ setSelectedElevatorId ]);

    return (
        <Dialog
            id="assign-device-to-elevator-dialog"
            visible={ visible }
            titleKey="BUILDING.ELEVATORS.ASSIGN_TO"
        >
            <ol>
                { elevators.sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '')).map(e =>
                    <li key={ e.id }>
                        <RadioField
                            id={ `adted-${e.id}` }
                            label={ e.displayName || t('NO_NAME') }
                            myValue={ e.id }
                            input={ {
                                value: selectedElevatorId,
                                name: 'elevator',
                                onChange: handleChange,
                            } }
                        />
                    </li>
                ) }
                { machineRoom &&
                    <li className="_machine_room">
                        <RadioField
                            id={ `adted-${machineRoom.id}` }
                            label={ t('BUILDING.ELEVATORS.MACHINE_ROOM') }
                            myValue={ machineRoom.id }
                            input={ {
                                value: selectedElevatorId,
                                name: 'elevator',
                                onChange: handleChange,
                            } }
                        />
                    </li>
                }
            </ol>
            <div>
                <button
                    id="assign-device-button"
                    className="ui primary red button"
                    disabled={ busy }
                    onClick={ () => onAssign(selectedElevatorId) }
                >
                    { t('COMMAND.ASSIGN') }
                </button>
                <button
                    id="cancel-assign-button"
                    className="ui grey button"
                    disabled={ busy }
                    onClick={ onCancel }
                >
                    { t('COMMAND.CANCEL') }
                </button>
            </div>
        </Dialog>
    );
};
